import { useState } from 'react';
import { PaymentMethod } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { CardACHSelection } from '@frontend/payments-card-on-file';
import { Modal } from '@frontend/design-system';

export const EditBillingMethodModal = ({
  patientId,
  patientEmail,
  handleSetBillingMethod,
  onClose,
  paymentAmount,
  minACHAmount,
  achDisabledMessage,
  achDisabledByCadence,
  locationId,
}: {
  patientId?: string;
  patientEmail: string;
  handleSetBillingMethod: (pm: PaymentMethod) => void;
  onClose: () => void;
  paymentAmount: number;
  minACHAmount: number;
  achDisabledMessage: string;
  achDisabledByCadence: boolean;
  locationId: string | undefined;
}) => {
  const { t } = useTranslation('payments');
  const [selectedPM, setSelectedPM] = useState<PaymentMethod>();

  return (
    <CardACHSelection
      locationId={locationId}
      patientId={patientId}
      patientEmail={patientEmail || ''}
      selectedPM={selectedPM}
      onChangePM={setSelectedPM}
      achDisabledMessage={achDisabledMessage}
      achDisabledByCadence={achDisabledByCadence}
      disableAch
      paymentAmount={paymentAmount}
      minACHAmount={minACHAmount}
      addACHContent={<CardACHSelection.AddACHForm />}
      addCardContent={<CardACHSelection.AddCardForm />}
    >
      <Modal.Header textAlign='left'>{t('Edit Billing Method')}</Modal.Header>
      <CardACHSelection.Content disableAch />
      <CardACHSelection.Action
        onCancel={onClose}
        primaryLabel={t('Save')}
        onPrimaryClick={() => selectedPM && handleSetBillingMethod(selectedPM)}
      />
    </CardACHSelection>
  );
};
